<template>
    <div class="main">
       <Topbar />
       <div class="container-fluid text-left pl-2 pr-2 d-flex justify-content-center mb-0">
            <div class="card shadow col-md-6 p-0 mb-0">
                <div class="card-header py-1" :style="{ backgroundColor: moduloAtual().color }">
                    <span class="m-0 font-weight-bold text-white small">
                        <div class="row">
                            <div class="col-7 col-md-7 col-lg-7">
                                <router-link :to="'/inventario'">
                                    <em class="fa fa-arrow-circle-left mr-2 text-white"></em>
                                </router-link>
                                Inventario {{ this.inventario.idprot_inventarios }}

                                <div v-show="carregando" class="spinner-grow">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="col-5 col-md-5 col-lg-5 text-right">
                                <div v-if="!inventario.aberto">
                                    <div class="aberto">Aberto</div>
                                </div>
                                <div v-if="inventario.aberto">
                                    <div class="fechado">Fechado</div>
                                </div>
                            </div>
                        </div>
                    </span>
                </div>
                <fieldset :disabled="carregando">
                    <div class="card-body bg-light small pl-2 pr-2 pt-1 pb-1">
                        <div class="card small mb-0">
                            <div class="card-body mb-0 p-1">
                                <div class="row">
                                    <div class="col-8 col-md-8 col-lg-8 font-weight-bold">{{ inventario.fantasia }} - Itens</div>
                                    <div class="col-4 col-md-4 col-lg-4 text-right">{{ this.inventario.totalitens }}</div>
                                </div>
                                <div class="row">
                                    <div class="col-8 col-md-8 col-lg-8 font-weight-bold">Estoque R$</div>
                                    <div class="col-4 col-md-4 col-lg-4 text-right">{{ this.inventario.totalvalor }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                    <div class="card-body mt-0 mb-0 bg-light small pl-2 pr-2 pt-0 pb-0">
                        <div class="small" v-for="(item) in conferencias" :key="item.conferencia">
                            <div class="card mb-2">
                                <div :class="['card-header', 'p-0 pl-2 pr-2', item.class]">
                                    <span class="m-0">
                                        <div class="row">
                                            <div class="col-10 col-md-10 col-lg-10 font-weight-bold">
                                                Conferência 
                                                {{ item.conferencia }}
                                            </div>
                                            <div class="col-2 col-md-2 com-lg-2 text-right" v-if="!inventario.aberto">
                                                <router-link :to="'/inventario/contagem/' + inventario.idprot_inventarios + '/' + item.conferencia">
                                                    <button class="btn btn-sm btn-info pt-0 pb-0 icon-go-conference">
                                                        <em class="fa fa-arrow-circle-right m-0"></em>
                                                    </button>
                                                    
                                                </router-link>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                                <div class="card-body p-1">
                                    <div class="row">
                                        <div class="col-8 col-md-8 col-lg-8 font-weight-bold">
                                            Total Operadores
                                        </div>
                                        <div class="col-4 col-md-4 col-lg-4 text-right">
                                            {{ item.totalOperadores }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-8 col-md-8 col-lg-8 font-weight-bold">
                                            Itens Contados
                                        </div>
                                        <div class="col-4 col-md-4 col-lg-4 text-right">
                                            {{ item.totalItensContados }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-8 col-md-8 col-lg-8 font-weight-bold">
                                            Total SKU'S
                                        </div>
                                        <div class="col-4 col-md-4 col-lg-4 text-right">
                                            {{ item.totalSku }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-8 col-md-8 col-lg-8 font-weight-bold">
                                            SKU's Contados
                                        </div>
                                        <div class="col-4 col-md-4 col-lg-4 text-right">
                                            {{ item.totalSkuContados }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-8 col-md-8 col-lg-8 font-weight-bold">
                                            SKU's Divergentes
                                        </div>
                                        <div class="col-4 col-md-4 col-lg-4 text-right">
                                            {{ item.totalItensSkuDivergentes + 0 }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-8 col-md-8 col-lg-8 font-weight-bold">
                                            itens do SKU's Divergentes
                                        </div>
                                        <div class="col-4 col-md-4 col-lg-4 text-right">
                                            {{ item.totalSkusItensDivergentes }}
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-md-12">
                                            <div class="progress" style="max-width: 100%; height: 10px;">
                                                <div class="progress-bar progress-bar-stripedd"
                                                    :style="{
                                                        width: item.barraSkusContatos + '%',
                                                        backgroundColor: '#66b400'
                                                    }">
                                                </div>
                                                <div class="progress-bar progress-bar-stripedd"
                                                    :style="{
                                                        width: item.barraSkusDivergentes + '%',
                                                        backgroundColor: 'rgb(141, 3, 72)'
                                                    }">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-8 col-md-8 col-lg-8 font-weight-bold">
                                            Enderecos contados
                                        </div>
                                        <div class="col-4 col-md-4 col-lg-4 text-right">
                                            {{ item.totalEnderecosContados }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-8 col-md-8 col-lg-8 font-weight-bold">
                                            Total Endereços
                                        </div>
                                        <div class="col-4 col-md-4 col-lg-4 text-right">
                                            {{ item.totalEnderecos }}
                                        </div>
                                    </div>

                                    <div class="row mt-1">
                                        <div class="col-md-12">
                                            <div class="progress" style="max-width: 100%; height: 10px;">
                                                <div class="progress-bar progress-bar-stripped"
                                                    :style="{
                                                        width: item.barraEnderecosContatos + '%',
                                                        backgroundColor: '#66b400'
                                                    }">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-body mt-0 mb-0 bg-light small pl-2 pr-2 pt-0">
                        <div class="card mt-0">
                            <div class="card-body p-1">
                                <div v-if="addNovaConferencia">
                                    <button class="btn btn-primary btn-block btn-sm" @click="() => confirmarAddConferencia()">
                                        Adicionar Conferência
                                        <em class="fa fa-plus-circle ml-2"></em>
                                    </button>
                                </div>

                                <div class="mt-1" v-if="!inventario.aberto">
                                    <button class="btn btn-danger btn-block btn-sm" @click="() => confirmarFechamento()">
                                        Fechar Inventário
                                        <em class="fa fa-times ml-2"></em>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <LogoutModal/>
        <Modal
            id="modalFechamento"
            title="Confirme:"
            :confirmFunction="() => okConfimarAddConferencia()"
            :carregando="carregando"
        >
            Se houver divergências, uma nova conferência será aberta
            <br>
            Deseja continuar?
        </Modal>
        <Modal
            id="modalAddConference"
            title="Confirme:"
            :confirmFunction="() => okConfimarAddConferencia()"
            :carregando="carregando"
        >
            Deseja adicionar uma nova conferencia?
        </Modal>

        <Modal
            id="modal2"
            title="Atenção!"
            :confirmFunction="() => okConfimarFechamento()"
            :carregando="carregando"
            :cancelFunction="() => closeModal('modal2')"
        >
            Não há divergências na contagem
            <br>
            Deseja finalizar este inventário?
        </Modal>

         <Modal
            id="modalShowMessageConferenciaCriada"
            title="Informação"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => reloadPage()"
            cancelText="OK"
        >
            <em class="fa fa-info-circle text-info fa-4x"></em>
            <br>
            <br>
            Nova conferencia criada!
        </Modal>
    </div>
</template>

<script>
// @ is an alias to /src
import Topbar from '@/components/Topbar.vue'
import LogoutModal from '@/components/LogoutModal.vue'
import ViewMixin from './ViewMixin'
import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
import api from '../services/api'
import api_inventario from '../services/api-inventario'
import { moneyFormat } from "../utils";
import Modal from "../components/Modal.vue";
import $ from "jquery";

export default {
    name: 'InventarioDetalhes',
    mixins: [ViewMixin],
    components: {
        Topbar,
        LogoutModal,
        Modal,
    },

    data: () => {
        return {
            inventario : {},
            conferencias: [],
            addNovaConferencia: false,
            nextConference: 0,
            conferenciaCriadaNoBotaoFinalizar: false,
        };
    },

    async mounted() {
        try {
            await this.validarToken();
            await this.getInventary();
            await this.getConfereces();
        } catch (e) {
            if (e instanceof TokenInvalidoException) {
                this.handleTokenInvalidoException();
            } else if (e instanceof ServerErrorException) {
                alert(e.message);
            } else {
                alert(DEFAULT_ERROR_MESSAGE);
            }      
        }
    },

    methods: {

        reloadPage() {
            window.location.reload();
        },

        closeModal(modal) {
            $("#"+modal).modal("hide");
        },

        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString('pt-BR');
        },

        async validarToken() {
            this.carregando = true;
            await api.get("/validar-token");
            this.carregando = false;
        },

        async getInventary() {
            this.carregando = true; 
            
            try {
                let id = this.$route.params.id;
                let response = await api_inventario.get(`/inventario/${id}`);
                this.inventario = response.data.inventario
                this.inventario["totalvalor"] = moneyFormat(this.inventario.totalvalor);
                
            } catch (e) {
                console.error(e);
            }
            this.carregando = false;
        },

        async getConfereces() {
            this.carregando = true; 
            
            try {
                let id = this.$route.params.id;
                let response1 = await api_inventario.get(`/conferencias/${id}`);
               
                let qtdConferencias = response1.data.qtde;
                this.qtdConferencias = qtdConferencias;

                this.addNovaConferencia = qtdConferencias != 5 && this.inventario.aberto == 0

                for (let i = 0; i < qtdConferencias; i++) {
                    let idConferencia = i+1;
                    this.nextConference = idConferencia+1;

                    let response2 = await api_inventario.get(`/conferencia/detalhe/${id}/${idConferencia}`);
                    let conferenciaColor = this.inventario.aberto == 1  ? "bg-success" : "bg-warning";
                    let barraSkusContatos = response2.data.details.totalSkuContados / response2.data.details.totalSku * 100;
                    let barraSkusDivergentes = response2.data.details.totalSkusItensDivergentes / response2.data.details.totalSku * 100;
                    let barraEnderecosContatos = response2.data.details.totalEnderecosContados / response2.data.details.totalEnderecos * 100;

                    response2.data.details["class"] = conferenciaColor;
                    response2.data.details["conferencia"] = idConferencia;
                    response2.data.details["barraSkusContatos"] = barraSkusContatos;
                    response2.data.details["barraSkusDivergentes"] = barraSkusDivergentes;
                    response2.data.details["barraEnderecosContatos"] = barraEnderecosContatos;
                    this.conferencias.push(response2.data.details);
                }
            } catch (e) {
                console.error(e);
            }
            this.carregando = false;
        },

        confirmarFechamento() {
            this.conferenciaCriadaNoBotaoFinalizar = true;
            setTimeout(() => {
                $("#modalFechamento").modal("show");
            }, 100);
        },

        async okConfimarFechamento() {
            this.carregando = true; 
            
            try {
                $("#modalFechamento").modal("hide");
                let id = this.$route.params.id;

                const inventary = {
                    idInventario: id
                };
                let response = await api_inventario.post('/finalizar/inventario', inventary);
                if (response.data.status === "OK") {
                    window.location.reload(); 
                }
            } catch (e) {
                alert(e.message);
            }
            this.carregando = false;
        },

        confirmarAddConferencia() {
            setTimeout(() => {
                $("#modalAddConference").modal("show");
            }, 100);
        },

        async okConfimarAddConferencia() {
            this.carregando = true; 
            
            try {
                $("#modalAddConference").modal("hide");
                let id = this.$route.params.id;

                const conference = {
                    idInventario: parseInt(id),
                    idConferencia: this.nextConference
                };

                let response = await api_inventario.post('/conferencia/adicionar', conference);
                if (response.data.update > 0) {
                    if (this.conferenciaCriadaNoBotaoFinalizar) {
                        $("#modalFechamento").modal('hide');
                        $("#modalShowMessageConferenciaCriada").modal("show");
                    } else {
                        window.location.reload();
                    }
                } else {
                    $("#modal2").modal("show");
                }

                this.conferenciaCriadaNoBotaoFinalizar = false;
            } catch (e) {
                alert(e.message);
            }
            this.carregando = false;
        }
    }
}
</script>

<style scoped lang="scss">
    .icon-go-conference {
        position: absolute;
        top: -2px;
        right: 5px;
        font-size: 12px;
    }

    .aberto {
        width: 50px;
        background-color: #28A745;
        padding-top: 1px;
        padding-bottom: 1px;
        text-align: center;
        border-radius: 10px 10px;
        color: #FFF;
        font-size: 10px;
        margin-left: auto;
        margin-top: 2px;
    }

    .fechado {
        width: 50px;
        background-color: #DC3545;
        padding-top: 1px;
        padding-bottom: 1px;
        text-align: center;
        border-radius: 10px 10px;
        color: #FFF;
        font-size: 10px;
        margin-left: auto;
        margin-top: 2px;
    }

    .main {
        padding-top: 75px;
    }
</style>